export const PROJECT_LIST = '/project/list';
export const PROJECT_JOINED = '/project/get-joined-project';
export const PROJECT_CREATE = '/project/create';
export const PROJECT_UPDATE = '/project/update';
export const PROJECT_DELETE = '/project/delete';
export const PROJECT_DETAILS = '/project/details';
export const PROJECT_MEMBERS = '/project/get-members';
export const PROJECT_ALL = '/project/list';